import styled from 'styled-components';
import Tabs from '../../../Tabs';

const StyledExpenseDetailsPanel = styled.div`
  width: 100%;
`;

const StyledExpenseDetailsPanelTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    padding: 24px 0;
  }

  .ant-tabs-content {
    padding: 0 16px;
  }
`;


export {
  StyledExpenseDetailsPanel,
  StyledExpenseDetailsPanelTabs,
}
